<script lang="ts">
  import { createAvatar, type Result } from '@dicebear/core';
  import { identicon } from '@dicebear/collection';
  import { browser } from '$app/environment';

  export let src: string | undefined;
  export let alt = '';
  export let seed = '';
  export let imgClass = '';

  let image: HTMLImageElement;
  let loadFailed = false;
  let imageLoaded = false;
  let placeholderImg: Result | null = null;

  function generatePlaceholder() {
    if (browser && (loadFailed || !src)) {
      placeholderImg = createAvatar(identicon, {
        seed: seed || (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString()),
      });
    }
  }

  $: if (loadFailed || !src) {
    generatePlaceholder();
  }
</script>

{#if browser}
  <div class="aspect-square w-full {$$props.class}">
    <img
      bind:this={image}
      on:error={() => {
        loadFailed = true;
      }}
      on:load={() => {
        imageLoaded = true;
      }}
      {src}
      {alt}
      class:sr-only={!image?.complete || !imageLoaded}
      class="aspect-square w-full object-contain object-center {imgClass}"
    />
    <div
      class:hidden={image?.complete || loadFailed || imageLoaded}
      class="bg-gray-dark-4 h-full w-full animate-pulse rounded"
    ></div>
    {#if loadFailed || !src}
      {@html placeholderImg}
    {/if}
  </div>
{/if}
